import React, {PropsWithChildren} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {cn, DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import {PATHS} from 'routes/constants';
import {useFetchLockConditions, usePath} from 'hooks';
import {useLayoutMode} from 'hooks/useLayoutMode';
import Page from 'components/Page';

type InternalRemoteAccessProps = PropsWithChildren & {
  subtitle?: string;
  isLoading?: boolean;
  title?: string;
};
function InternalRemoteAccess({
  subtitle,
  children,
  isLoading,
  title,
}: InternalRemoteAccessProps) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {isMatch} = useScreenResize(DEVICE.laptop);
  const {getFullPath} = usePath();
  const {data: locksConditions} = useFetchLockConditions();
  const layoutMode = useLayoutMode();

  const goToHome = () => {
    navigate(getFullPath(PATHS.home));
  };

  if (locksConditions && !locksConditions?.is_show_keys_enabled) {
    return <Navigate to={`../`} />;
  }

  return (
    <Page
      isSubHeaderVisible={layoutMode === 'default'}
      title={title || t('my_keys')}
      isLoading={isLoading}
      navBarTitle={isMatch ? t('my_keys') : t('virtual_keys')}
      subtitle={subtitle}
      hideSubPanelBackButton
      onBackButtonClick={goToHome}
      className={cn('remote-access-view', {
        'kiosko:pt-[80px]': layoutMode === 'kiosko',
      })}
    >
      {children}
    </Page>
  );
}

export default InternalRemoteAccess;
